
export class CardSuggestionTranslationModel {

    constructor(
        public title: string,
        public location: string,
        public details : string,
        public link: string,
        public locale : string
    ) {}
}